module.exports = __webpack_public_path__ + "img/img69.a7341363.svg";